// assets/note-prefix.js

// Fix note display in cart drawer vs cart page
document.addEventListener('DOMContentLoaded', function() {
  // Initial fix on page load
  fixNoteDisplay();
  
  // Set up a mutation observer to detect cart drawer opening
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('js-drawer-open-right') || 
          document.body.classList.contains('js-drawer-open-right')) {
        fixNoteDisplay();
      }
    });
  });
  
  // Observe body class changes (most drawer implementations add a class to body)
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  
  // Set up click listener for any cart open buttons
  document.querySelectorAll('[data-cart-drawer-toggle], .cart-link').forEach(button => {
    button.addEventListener('click', function() {
      // Use setTimeout to run after the drawer opens
      setTimeout(fixNoteDisplay, 100);
    });
  });
  
  function fixNoteDisplay() {
    // Get all note elements
    const noteElements = document.querySelectorAll('.cart-item__note[data-note-prefix]');
    
    noteElements.forEach(note => {
      const notePrefix = note.getAttribute('data-note-prefix');
      const isInCartPage = note.closest('.cart-page, .cart__container, .cart-template, #MainContent .cart');
      const isInDrawer = note.closest('.cart-drawer, .drawer, .cart-dropdown');
      
      // Reset content first
      note.textContent = notePrefix;
      
      // Apply extended format only on cart page
      if (isInCartPage && !isInDrawer) {
        const shippingTime = note.getAttribute('data-shipping-time') || '';
        note.textContent = notePrefix + ' Item' + (shippingTime ? ' ' + shippingTime : '');
      }
    });
  }
});